export interface FilterCheckbox {
  label: string;
  count: number;
  checked: boolean;
  server_label: string;
  filterUpdate?: Function;
}

export type CanResetAnim = "show" | "hide" | "init";
export type PropertyTypes = "estates" | "lands";

export type PropertySubtype =
  | "Apartment"
  | "House"
  | "Condo"
  | "Townhouse"
  | "Studio"
  | "Villa";
export const PROPERTY_SUBTYPES: PropertySubtype[] = [
  "Apartment",
  "House",
  "Condo",
  "Townhouse",
  "Studio",
  "Villa",
];

export interface FilterState {
  expanded: boolean;
  canReset: CanResetAnim;
}

export interface ExpandFiltersMap {
  price_range: FilterState;
  min_invest: FilterState;
  irr: FilterState;
  apr: FilterState;
  bedroom: FilterState;
  bathroom: FilterState;
  countryId: FilterState;
  stage: FilterState;
  property_type: FilterState;
  subtype: FilterState;
  providerIds:FilterState;
  documents:FilterState;
  rating:FilterState;
}
